export default __webpack_public_path__ + "static/media/csv.ea6e1e6e.svg";